import {AnyAction} from 'redux';
import FrameActionType from './FrameActionType';

/**
 * Akce frame.
 */
const FrameActions = {
    /**
     * Nastaví pozastavení zpracování zpráv ve frontě.
     *
     * @param area - Oblast store.
     * @param suspended - Zda je zpracování pozastaveno.
     * @returns Akce.
     */
    setPostSuspended: (area: string, suspended: boolean): AnyAction => ({
        type: FrameActionType.SET_POST_SUSPENDED,
        area,
        suspended,
    }),

    /**
     * Zařadí zprávu pro frame do fronty.
     *
     * @param area - Oblast store.
     * @param message - Message pro poslání.
     * @returns Akce.
     */
    postMessage: (area: string, message: any): AnyAction => ({
        type: FrameActionType.POST_MESSAGE,
        area,
        message,
    }),

    /**
     * Smaže všechny zprávy ve frontě pro frame.
     *
     * @param area - Oblast store.
     * @returns Akce.
     */
    clearMessages: (area: string): AnyAction => ({
        type: FrameActionType.CLEAR_MESSAGES,
        area,
    }),
};

export default FrameActions as Readonly<typeof FrameActions>;
